export default function Auditing() {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-0295238 elementor-section-full_width elementor-reverse-tablet elementor-reverse-mobile elementor-section-height-default elementor-section-height-default"
      data-id="0295238"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-073c597"
          data-id="073c597"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-b559927 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="b559927"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-9e9fa25"
                  data-id="9e9fa25"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-6b5dc08 elementor-widget elementor-widget-heading"
                      data-id="6b5dc08"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Pre-Assessments
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-1b867dd elementor-widget elementor-widget-text-editor"
                      data-id="1b867dd"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Get a complete report on any compliance gaps that
                          might be there in your company’s current state and
                          close them
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ac0847b"
                  data-id="ac0847b"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-937c6c4 elementor-widget elementor-widget-heading"
                      data-id="937c6c4"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Internal Audits
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-bb9e6d0 elementor-widget elementor-widget-text-editor"
                      data-id="bb9e6d0"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          A qualified auditor will do an internal audit in
                          accordance with the standard and also get your
                          documentation updated for future audits
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-77af17b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="77af17b"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-ee724ef"
                  data-id="ee724ef"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-62cf9df elementor-widget elementor-widget-heading"
                      data-id="62cf9df"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Supply Chain Audits
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-fc918ce elementor-widget elementor-widget-text-editor"
                      data-id="fc918ce"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Industry-certified experts ensure will that your
                          suppliers meet the required quality standards and
                          specifications
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7df5ffc"
                  data-id="7df5ffc"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-c345168 elementor-widget elementor-widget-heading"
                      data-id="c345168"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Cybersecurity Audits
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-d7545ad elementor-widget elementor-widget-text-editor"
                      data-id="d7545ad"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          A qualified auditor will do an internal audit in
                          accordance with the standard and also get your
                          documentation updated for future audits
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-28da9e7 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="28da9e7"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-38bc858"
                  data-id="38bc858"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-8a56573 elementor-widget elementor-widget-heading"
                      data-id="8a56573"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          External/Third Party Audits
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-8626406 elementor-widget elementor-widget-text-editor"
                      data-id="8626406"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          An independent auditor, or one who is not affiliated
                          with the organization, will perform an audit for the
                          benefit of the customers of the organization
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-9aac472"
                  data-id="9aac472"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-fa8715c elementor-widget elementor-widget-heading"
                      data-id="fa8715c"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h4 className="elementor-heading-title elementor-size-default">
                          Compliance Audits
                        </h4>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-4edf785 elementor-widget elementor-widget-text-editor"
                      data-id="4edf785"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        Our expert auditors conduct an audit to make sure that
                        your company is all set for certification or already
                        compliant
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-70eb217"
          data-id="70eb217"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-34b3ce8 elementor-widget elementor-widget-heading"
              data-id="34b3ce8"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h3 className="elementor-heading-title elementor-size-default">
                  Auditing
                </h3>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-8a43179 elementor-widget elementor-widget-text-editor"
              data-id="8a43179"
              data-element_type="widget"
              data-widget_type="text-editor.default"
            >
              <div className="elementor-widget-container">
                Get all your finances in order with the help of some of the best
                ISO auditors – from pre-assessments to external audits, we cover
                everything
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
